export const LIVE_ORDER_CARD_STATUS = 'LIVE';
export const LIVE_ORDER_CARD_TEXT = 'Your order(s) are in progress';
export const LIVE_ORDER_BUTTON = 'View Status';
